import React from 'react'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import { YouTube, Instagram } from '@mui/icons-material'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const youtube = 'https://www.youtube.com/@langalearn'
const instagram= 'https://www.instagram.com/langalearn'
const tiktok = 'https://www.tiktok.com/@langa_learn'
const discord = 'https://discord.com/channels/1071961840025870347/1071963165484650516'

const TikTokIcon = ({ color = 'grey' }) => {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="8%"
      height="8%"
    >
      <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
    </svg>
  );
};

const DiscordIcon = ({ color = 'grey' }) => {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -28.5 256 256"
      width="8%"
      height="8%"
    >
        <path d="M216.856339,16.5966031 C200.285002,8.84328665 182.566144,3.2084988 164.041564,0 C161.766523,4.11318106 159.108624,9.64549908 157.276099,14.0464379 C137.583995,11.0849896 118.072967,11.0849896 98.7430163,14.0464379 C96.9108417,9.64549908 94.1925838,4.11318106 91.8971895,0 C73.3526068,3.2084988 55.6133949,8.86399117 39.0420583,16.6376612 C5.61752293,67.146514 -3.4433191,116.400813 1.08711069,164.955721 C23.2560196,181.510915 44.7403634,191.567697 65.8621325,198.148576 C71.0772151,190.971126 75.7283628,183.341335 79.7352139,175.300261 C72.104019,172.400575 64.7949724,168.822202 57.8887866,164.667963 C59.7209612,163.310589 61.5131304,161.891452 63.2445898,160.431257 C105.36741,180.133187 151.134928,180.133187 192.754523,160.431257 C194.506336,161.891452 196.298154,163.310589 198.110326,164.667963 C191.183787,168.842556 183.854737,172.420929 176.223542,175.320965 C180.230393,183.341335 184.861538,190.991831 190.096624,198.16893 C211.238746,191.588051 232.743023,181.531619 254.911949,164.955721 C260.227747,108.668201 245.831087,59.8662432 216.856339,16.5966031 Z M85.4738752,135.09489 C72.8290281,135.09489 62.4592217,123.290155 62.4592217,108.914901 C62.4592217,94.5396472 72.607595,82.7145587 85.4738752,82.7145587 C98.3405064,82.7145587 108.709962,94.5189427 108.488529,108.914901 C108.508531,123.290155 98.3405064,135.09489 85.4738752,135.09489 Z M170.525237,135.09489 C157.88039,135.09489 147.510584,123.290155 147.510584,108.914901 C147.510584,94.5396472 157.658606,82.7145587 170.525237,82.7145587 C183.391518,82.7145587 193.761324,94.5189427 193.539891,108.914901 C193.539891,123.290155 183.391518,135.09489 170.525237,135.09489 Z" />
    </svg>
  );
};

const SocialList = ({
  siteTwitter,
  siteFacebook,
  
}) => 
    <React.Fragment>
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Social
      </Typography>
      <List>
        <ListItem disablePadding >
          <ListItemButton >
            <ListItemIcon >
              <TwitterIcon />
            </ListItemIcon>
            <Link href={siteTwitter} target='_blank' color='#6415ff' >
              <ListItemText primary='Twitter' />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding >
          <ListItemButton >
            <ListItemIcon >
              <FacebookIcon />
            </ListItemIcon>
            <Link href={siteFacebook} target='_blank' color='#6415ff' >
              <ListItemText primary='Facebook' />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding >
          <ListItemButton >
            <ListItemIcon >
              <YouTube />
            </ListItemIcon>
            <Link href={youtube} target='_blank' color='#6415ff' >
              <ListItemText primary='Youtube' />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding >
          <ListItemButton >
            <ListItemIcon >
              <Instagram  />
            </ListItemIcon>
            <Link href={instagram} target='_blank' color='#6415ff' >
              <ListItemText primary='Instagram' />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding >
          <ListItemButton >
            <TikTokIcon   />
            <Link href={tiktok} target='_blank' color='#6415ff' style={{marginLeft: 30}} >
              <ListItemText primary='Tiktok' />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding >
          <ListItemButton >
            <DiscordIcon  />
            <Link href={discord}  target='_blank' color='#6415ff' style={{marginLeft: 30}} >
              <ListItemText primary='Discord' />
            </Link>
          </ListItemButton>
        </ListItem>
      </List>
    </React.Fragment>

export default SocialList;